import React, { useState } from "react";
import { Link } from "react-router-dom";
import PictureImage from '../Common/PictureImage';
import "./FbaPrepServices.css";

const services = [
  {
    img: "/Images/Inventory_inspection.webp",
    alt: "Worker scanning packages in warehouse",
    title: "Inventory Inspection\n& Quality Control",
    desc: "Every unit is carefully inspected to meet Amazon requirements, ensuring accurate labelling, product condition, and full compliance before reaching fulfilment centres.",
    ctaHref: "/blog/fba-prep-requirements-uk-amazon-seller-guide-2026",
    ctaLabel: "See our FBA quality control process",
  },
  {
    img: "/Images/FNSKU_LABELING.webp",
    alt: "Hands applying label to package",
    title: "FNSKU Labeling\n(Done to Spec)",
    desc: "Accurate FNSKU labelling, poly bagging, and package preparation completed to Amazon standards, ensuring compliance, faster receiving, and smooth inventory processing.",
    ctaHref: "/blog/fnsku-labelling-service-uk",
    ctaLabel: "Learn more about FNSKU labelling UK",
  },
  {
    img: "/Images/PROTECTOVE-PREP-AND-POLY-BAGING.webp",
    alt: "Worker inspecting boxes in warehouse",
    title: "Protective Prep\n& Poly Bagging",
    desc: "Secure label application, barcode verification, and protective packaging completed to Amazon standards, ensuring accurate inventory handling, compliance, and efficient fulfilment operations.",
    ctaHref: "/blog/amazon-poly-bag-requirements-uk",
    ctaLabel: "Read Amazon poly bag requirements UK",
  },
  {
    img: "/Images/OPTIMIZED-CASE-PACKAGING.webp",
    alt: "Worker organizing large pallets",
    title: "Optimized\nCase Packing",
    desc: "Optimised case packing maximises storage efficiency while meeting Amazon carton requirements, protecting inventory and reducing unnecessary fulfilment costs.",
    ctaHref: "/amazon-fba-shipments",
    ctaLabel: "See Amazon FBA shipment preparation",
  },
];

function renderTitle(title: string) {
  return title.split("\n").map((line, j, lines) => (
    <React.Fragment key={j}>
      {line}
      {j < lines.length - 1 && <br />}
    </React.Fragment>
  ));
}

const FBAPrepServices: React.FC = () => {
  const [expandedCard, setExpandedCard] = useState<number | null>(null);

  const handleCardActivate = (index: number) => {
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <section className="fps-section">
      <div className="fps-header">
        <h2 className="fps-title">
          Our <span style={{ color: '#f58030' }}>Amazon FBA Prep</span> Services: What&apos;s Included
        </h2>
        <p className="fps-subtitle">
          Our <strong>Amazon FBA prep service UK</strong> includes product inspections, FNSKU labelling, poly bagging, bundling, carton preparation, pallet forwarding, shipment creation, inventory storage, and dispatch to Amazon fulfilment centres from Milton Keynes. Tour the{' '}
          <Link to="/amazon-fba-prep-centre-services">FBA prep centre facility</Link>, compare{' '}
          <Link to="/amazon-fba-prep-pricing">Amazon FBA prep cost &amp; pricing</Link>, or see niche workflows for{' '}
          <Link to="/amazon-fba-prep-private-label">private label</Link> and{' '}
          <Link to="/amazon-fba-prep-wholesale">wholesale FBA prep UK</Link>.
        </p>
      </div>

      <div className="fps-grid">
        {services.map((svc, i) => (
          <article
            className={`fps-card${expandedCard === i ? ' fps-card--expanded' : ''}`}
            key={svc.title}
            onClick={() => handleCardActivate(i)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleCardActivate(i);
              }
            }}
            tabIndex={0}
            aria-expanded={expandedCard === i}
          >
            <div className="fps-img-wrap">
              <PictureImage src={svc.img} alt={svc.alt} className="fps-img" />
            </div>
            <div className="fps-card-body">
              <h3 className="fps-card-title">{renderTitle(svc.title)}</h3>
              <p className="fps-card-desc">{svc.desc}</p>
              <Link
                to={svc.ctaHref}
                className="fps-card-cta"
                onClick={(e) => e.stopPropagation()}
              >
                {svc.ctaLabel} →
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default FBAPrepServices;
